/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RoomOutput.vue?vue&type=template&id=38dce38a"
import script from "./RoomOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomOutput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports